// Keep quote links aligned with the customer's current size and fit selection.
function updateSkateRequest(link) {
  const section = link.closest('[id^="shopify-section-"]');
  const picker = section?.querySelector('variant-picker');
  if (!picker) return;
  const selected = [...picker.querySelectorAll('input[type="radio"]:checked, select')]
    .map(input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.value : input.value)
    .filter(Boolean);
  const title = link.dataset.skateRequestTitle;
  const url = new URL(link.href, location.origin);
  url.searchParams.set('tsd_product', title + (selected.length ? ' — ' + selected.join(' / ') : ''));
  link.href = url.pathname + url.search + url.hash;
}

document.querySelectorAll('[data-skate-request-title]').forEach(updateSkateRequest);
document.addEventListener('change', event => {
  if (!(event.target instanceof Element) || !event.target.closest('variant-picker')) return;
  event.target.closest('[id^="shopify-section-"]')?.querySelectorAll('[data-skate-request-title]').forEach(updateSkateRequest);
});
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-skate-request-title]');
  if (link) updateSkateRequest(link);
});
